import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { of } from 'rxjs';

export const cssJsResolver = () => {
	const document = inject(DOCUMENT);
	const body = document.querySelector('body');

	// add stylesheet to body
	const style = document.createElement('link');
	style.rel = 'stylesheet';
	style.href =
		'/assets/outsourced/what-degree-can-i-do-with-my-alevels/css/what-degree-can-i-do-with-my-alevels.css';
	body?.appendChild(style);

	// Add the script tag to the body
	const script = document.createElement('script');
	script.src =
		'/assets/outsourced/what-degree-can-i-do-with-my-alevels/what-degree-can-i-do-with-my-alevels.js';
	body?.appendChild(script);

	return of(true);
};
